module.exports = __webpack_public_path__ + "static/media/2.4_preview.6c2ea46d.png";